<template>
    <modal ref="modal" unclosable>
        <div id="sub-wrapper">
            <div class="title">{{ error }}</div>
            <div class="outputs">
                <div v-for="error in errors" :key="error.output_id" class="output">
                    <img :src="imgSrc(error.kind)"/>
                    <div>{{ error.error }}</div>
                </div>
            </div>
            <button @click="hide">{{ $t('modals.start_live_error.button') }}</button>
        </div>
    </modal>
</template>

<script>
import distributor from '@/services/distributor'

export default {
  data () {
    return {
      error: '',
      errors: []
    }
  },
  methods: {
    show (error, errors) {
      this.error = error
      this.errors = errors
      this.$refs.modal.show()
    },
    hide () {
      this.$refs.modal.hide()
    },
    imgSrc (kind) {
      return distributor.imgSrc(kind)
    }
  }
}
</script>

<style scoped>

#sub-wrapper {
  width: 30em;
}

#sub-wrapper .title {
  margin-bottom: 0.75em;
}

#sub-wrapper .outputs {
  margin-bottom: 1.5em;
}

#sub-wrapper .output {
  align-items: center;
  display: flex;
  flex-direction: row;
  margin-bottom: 0.5em;
}

#sub-wrapper .output:last-child {
  margin-bottom: 0;
}

#sub-wrapper .output img {
  background-color: #323232;
  border-radius: 0.3em;
  height: 2em;
  padding: 0.3em;
  margin-right: 0.5em;
}

#sub-wrapper .output > div {
  text-align: left;
}

</style>
